import { parseDateToISOWithTimezone } from "@/_old/utils/date";
import { useAuth } from "@/core/components/auth/store/auth";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useMemo, useState } from "react";
import { getLocations } from "../services/locations-service";
import { GetLocationsParams, GetLocationsResponse } from "../types";
import { useDashboardFilters } from "@/dashboard/store/useDashboardFilters";

const useLocationFilters = () => {
  const {
    userInfo: { user },
  } = useAuth();
  const { filters } = useDashboardFilters();

  const [searchParams, setSearchParams] = useState<GetLocationsParams>({
    company_id: user.leagues_id[0],
    start_date: parseDateToISOWithTimezone(new Date(filters.startDate)),
    end_date: parseDateToISOWithTimezone(new Date(filters.endDate)),
  });

  const debouncedParams = useMemo(() => {
    return searchParams;
  }, [searchParams]);

  const {
    data: response,
    error,
    isLoading,
  } = useQuery<GetLocationsResponse>({
    queryKey: ["location-filters", debouncedParams],
    queryFn: async ({ signal }) => await getLocations(debouncedParams, signal),
  });

  const data = useMemo(() => {
    return response?.data || { spaces: [], cities: [] };
  }, [response]);

  useEffect(() => {
    setSearchParams((prev) => ({
      ...prev,
      start_date: parseDateToISOWithTimezone(new Date(filters.startDate)),
      end_date: parseDateToISOWithTimezone(new Date(filters.endDate)),
    }));
  }, [filters.startDate, filters.endDate]);

  return { data, error, isLoading, searchParams, setSearchParams };
};

export { useLocationFilters };
